import React from 'react';
import BootstrapNotifyContain from '../../Componant/Bonus-Ui/BootstrapNotify';

const BootstrapNotify = () => {
  return (
    <div className='page-body'>
      <BootstrapNotifyContain />
    </div>
  );
};

export default BootstrapNotify;
